module.exports = "/_next/static/images/linkedin-filled-icon-a97ee4341154c1eee94b297076b3536a.svg";